<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    금지 닉네임 설정
                </div>
                <div class="">
                    <member-list-prohibit-component :member-type="'prohibit'"></member-list-prohibit-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import MemberListProhibitComponent from "../../components/member/MemberListProhibitComponent";

export default {
    name: "Member",
    mixins: [],
    components: {MemberListProhibitComponent},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>
